{
  "brand": {
    "tagline": "一個會員帳戶，收藏每間喜愛店家。"
  },
  "common": {
    "continue": "繼續",
    "cancel": "取消",
    "close": "關閉",
    "done": "完成",
    "retry": "再試一次",
    "save": "儲存",
    "edit": "編輯",
    "publish": "發布",
    "search": "搜尋",
    "learnMore": "了解更多",
    "notAvailable": "暫未提供",
    "offline": "離線",
    "updated": "更新於 {time}"
  },
  "tabs": {
    "home": "首頁",
    "explore": "探索",
    "activity": "紀錄",
    "profile": "個人"
  },
  "home": {
    "greeting": "午安",
    "title": "你的獎賞",
    "showCard": "出示會員卡",
    "createCard": "建立會員卡",
    "noCard": "尚未建立會員卡",
    "createCardBody": "建立免費通用會員卡，開始收藏獎賞。",
    "rewardReady": "獎賞可兌換",
    "inProgress": "集印花中",
    "nearby": "探索附近店家",
    "emptyTitle": "開始收藏獎賞",
    "emptyBody": "在合作店家出示 Collectie 會員卡即可開始。",
    "stale": "離線期間顯示上次儲存的資料"
  },
  "card": {
    "universal": "一張會員卡 · 適用每間合作店",
    "title": "你的 Collectie 會員卡",
    "member": "會員",
    "memberCode": "會員 {code}",
    "scanHint": "請店員掃描此會員卡。",
    "wallet": "在 Apple Wallet 開啟",
    "lastRefresh": "上次更新：{time}",
    "brightness": "開啟此會員卡期間，螢幕會暫時調至較高亮度。",
    "codeUnavailable": "尚未有可掃描的條碼。請向店員出示上方的會員編號。",
    "preparing": "正在準備你的會員卡…"
  },
  "membership": {
    "eyebrow": "你的進度",
    "stamps": "印花",
    "progress": "已集 {current} / {target} 個印花",
    "progressTitle": "印花進度",
    "nextReward": "下一份獎賞",
    "availableRewards": "可用獎賞",
    "recentActivity": "最近紀錄",
    "terms": "計畫條款",
    "website": "前往商店網站",
    "joined": "加入日期：{date}",
    "oneMore": "再一個印花即可獲獎賞",
    "rewardReady": "你的獎賞已準備好"
  },
  "reward": {
    "available": "可使用",
    "redeemed": "已兌換",
    "expired": "已過期",
    "redeemAtCounter": "請由店員協助兌換",
    "validUntil": "有效至 {date}"
  },
  "boost": {
    "unlockTitle": "解鎖 App 加碼印花",
    "unlockBody": "連結 Collectie App，下次在此完成合資格消費可多獲一個印花。",
    "pendingTitle": "App 加碼印花已準備好",
    "pendingBody": "下次合資格消費可額外獲一個印花。",
    "applied": "已獲 App 加碼印花",
    "expired": "App 加碼印花已過期",
    "reversed": "App 加碼印花已撤銷",
    "validUntil": "請於 {date} 前使用"
  },
  "explore": {
    "eyebrow": "收藏身邊好店",
    "title": "探索合作店家",
    "searchPlaceholder": "咖啡、午餐、花店…",
    "nearYou": "附近店家",
    "newPartners": "新合作店家",
    "all": "全部",
    "coffee": "咖啡與茶",
    "food": "餐飲",
    "shops": "商店",
    "locationPrompt": "允許定位以按距離排列附近店家。",
    "noLocation": "不分享位置也可以瀏覽所有合作店家。",
    "viewMode": "探索顯示方式",
    "map": "地圖",
    "list": "列表",
    "loading": "正在載入合作店家位置⋯",
    "emptyTitle": "暫時沒有合作店家位置",
    "emptyBody": "店家的會員計畫發布後，新位置會顯示在這裡。",
    "errorTitle": "無法載入合作店家",
    "errorBody": "請檢查網路連線後再試。",
    "offline": "離線時顯示已儲存的合作店家位置",
    "locate": "定位我的位置",
    "locationDeniedTitle": "定位已關閉",
    "yourLocation": "你的位置",
    "viewShop": "查看店家",
    "website": "前往網站",
    "reward": "會員獎賞",
    "location": "位置",
    "openInMaps": "在地圖中開啟",
    "stampGoal": "印花目標",
    "clearSearch": "清除搜尋"
  },
  "activity": {
    "eyebrow": "你的收藏紀錄",
    "title": "紀錄",
    "earn": "已獲得印花",
    "bonus": "已套用 App 加碼印花",
    "rewardIssued": "已解鎖獎賞",
    "redeem": "已兌換獎賞",
    "adjustment": "餘額已調整",
    "reversal": "交易已撤銷",
    "expiry": "獎賞已過期",
    "empty": "你的 Collectie 紀錄會顯示在這裡。",
    "emptyTitle": "暫時沒有紀錄",
    "errorTitle": "暫時無法載入紀錄",
    "errorBody": "請檢查網路連線，然後再試一次。",
    "loading": "正在載入紀錄⋯",
    "loadMore": "載入較早紀錄",
    "loadingMore": "正在載入較早紀錄⋯"
  },
  "profile": {
    "eyebrow": "專屬於你",
    "title": "個人設定",
    "account": "帳戶",
    "provisional": "你的獎賞尚未受保障",
    "protected": "你的獎賞已受保障",
    "protect": "保障你的獎賞",
    "signInApple": "使用 Apple 繼續",
    "wallet": "Apple Wallet 會員卡",
    "replaceCard": "更換會員卡",
    "language": "語言",
    "languageSystem": "使用 iPhone App 語言",
    "serverLocale": "會員卡及訊息語言",
    "privacy": "隱私與資料",
    "export": "申請匯出資料",
    "delete": "刪除帳戶",
    "deleteTitle": "刪除你的 Collectie 帳戶？",
    "deleteBody": "你的會員卡將停止運作，店家會員資格會關閉，而 Apple Wallet 會員卡亦會從此 iPhone 移除。交易紀錄可能以無法直接識別你的形式保留作審計及防止詐騙用途。",
    "deleteConfirm": "刪除帳戶",
    "deleting": "正在刪除帳戶⋯",
    "deleteFailed": "未能刪除你的帳戶。你的會員卡仍可使用，請再試一次。",
    "browsing": "未建立會員卡，正在瀏覽",
    "memberCode": "Collectie 會員卡",
    "privacyIntro": "Collectie 只會使用營運通用會員卡及各店獨立會員計畫所需的資料。",
    "privacyIdentifiersTitle": "會員卡及裝置識別碼",
    "privacyIdentifiersBody": "我們會儲存不透明的使用者識別碼、會員卡憑證及經雜湊處理的 App 安裝識別碼，以安全識別你的會員卡。原始憑證只存於此 iPhone 的鑰匙圈，絕不記錄於日誌。",
    "privacyRewardsTitle": "會員及消費活動",
    "privacyRewardsBody": "我們會儲存店家會員資格、印花、獎賞及經店家確認的會員交易。每間店家只能查看自己店家的活動。",
    "privacyLocationTitle": "位置",
    "privacyLocationBody": "位置功能並非必要；只有在你點按「找出我的位置」後才會要求權限，並只在此 iPhone 上用於排列附近店家，不會傳送至 Collectie。",
    "privacyTrackingTitle": "不作廣告追蹤",
    "privacyTrackingBody": "Collectie 不使用廣告追蹤器、不出售個人資料，也不會為廣告用途合併你在不同店家的活動。",
    "privacyRetentionTitle": "刪除及保留",
    "privacyRetentionBody": "刪除帳戶會撤銷憑證並移除可直接識別你的資料。因審計、防止詐騙及法律責任所需，不可變更的交易紀錄可能會繼續保留。",
    "privacyPolicy": "閱讀完整隱私權政策",
    "support": "幫助與支援",
    "version": "版本 {version}",
    "versionLabel": "版本",
    "pilotUnavailable": "此試用版本尚未提供這項功能。"
  },
  "onboarding": {
    "eyebrow": "把每份會員獎賞收藏一起",
    "checkingBody": "正在此 iPhone 上尋找可存取的 Collectie 會員卡。",
    "checkingTitle": "正在尋找你的會員卡",
    "connecting": "正在連結獎賞⋯",
    "connectingBody": "請保持應用程式開啟，我們正安全地移轉你的會員資料。",
    "createCard": "建立我的 Collectie 會員卡",
    "creatingCard": "正在建立你的會員卡⋯",
    "createCardFailed": "無法建立你的會員卡。請檢查網路連線後再試。",
    "cardStartsEmpty": "你的會員卡會從零開始；只有在店家使用時，才會加入該店的會員計畫。",
    "checkWalletAgain": "再次檢查 Apple Wallet",
    "browseFirst": "暫不建立會員卡並探索",
    "continueWithoutCard": "不連結並繼續",
    "errorBody": "你的獎賞沒有變更。請檢查網路連線後再試。",
    "errorTitle": "未能連結你的會員卡",
    "foundTitle": "歡迎回來",
    "foundBody": "我們找到你的 Collectie 會員卡及現有獎賞。",
    "connect": "連結此會員卡",
    "noCardTitle": "開始使用 Collectie",
    "noCardBody": "立即建立會員卡，或保障你已有的獎賞。",
    "noManualEntry": "不需要輸入會員編號",
    "protectExisting": "保障現有獎賞",
    "separateShops": "每間店家的獎賞保持獨立",
    "skip": "暫時不要",
    "valuePreserved": "現有結餘保持不變"
  },
  "join": {
    "eyebrow": "Wallet 優先獎賞",
    "title": "在 {merchant} 收藏獎賞",
    "noApp": "不需要下載 App。",
    "noPii": "建立會員卡前不需要提供電子郵件或建立帳戶。",
    "body": "將 Collectie 會員卡加入 Apple Wallet，即可在所有合作店家使用。",
    "addWallet": "加入 Apple Wallet",
    "alreadyMember": "已有 Collectie？開啟你的會員卡。",
    "privacy": "繼續即表示你同意會員計畫條款，並確認已閱讀隱私權聲明。",
    "protectTitle": "你的會員卡已準備好",
    "protectBody": "安裝 Collectie 以保障獎賞並探索所有合作店家。",
    "getApp": "下載 Collectie App",
    "program": "集齊 {target} 個印花即可獲得獎賞。",
    "creating": "正在建立會員卡…",
    "added": "會員卡已準備好",
    "membershipReady": "會員資格已建立",
    "actionError": "未能準備你的會員資格。系統沒有加入任何消費或獎賞，請再試一次。",
    "fallback": "部分商店內容會以英文顯示。",
    "stampsToReward": "個印花可獲獎賞",
    "perPurchase": "每次已確認消費",
    "reward": "你的獎賞",
    "previewLabel": "你的通用會員卡",
    "previewTitle": "一張卡，適用於每間 Collectie 合作店家",
    "atThisShop": "在此店家",
    "merchantWebsite": "前往商店網站",
    "programDetails": "你可在這裡收藏",
    "terms": "會員計畫條款",
    "safeJoin": "此代碼只會加入或開啟會員資格；消費會在結帳時另行確認。",
    "loading": "正在載入商店獎賞…",
    "loadErrorTitle": "未能載入此商店",
    "loadErrorBody": "系統沒有建立會員資格或任何價值。請檢查網路連線後再試。",
    "notFoundTitle": "此商店目前不可使用",
    "notFoundBody": "分店或會員獎賞計畫可能已暫停。請向商店索取最新 Collectie 代碼。"
  },
  "merchant": {
    "auth": {
      "eyebrow": "商家登入",
      "title": "登入 Collectie",
      "body": "在一個安全的工作空間管理會員獎賞計畫，並讓結帳流程保持順暢。",
      "formLabel": "商家登入",
      "noPasswordTitle": "不需要記住密碼",
      "noPasswordBody": "我們會將短效驗證碼寄到已核准商家的電子郵件地址。",
      "email": "工作用電子郵件",
      "emailTitle": "使用電子郵件繼續",
      "emailHelp": "請使用店主或經理邀請你的電子郵件地址。",
      "sendCode": "發送登入驗證碼",
      "sending": "正在發送驗證碼…",
      "code": "六位數驗證碼",
      "codeTitle": "查看你的收件箱",
      "codeHelp": "輸入發送至 {email} 的驗證碼。",
      "localCode": "本機測試驗證碼：{code}",
      "verify": "驗證並繼續",
      "verifying": "正在驗證…",
      "changeEmail": "使用其他電子郵件",
      "requestError": "無法傳送驗證碼。請檢查電子郵件地址後再試。",
      "verifyError": "無法驗證此驗證碼。請檢查後再試。",
      "accessCodeTitle": "使用存取碼",
      "accessCodeBody": "輸入為此商家工作空間提供的存取碼。",
      "accessCode": "存取碼",
      "accessCodeContinue": "繼續",
      "accessCodeSigningIn": "正在開啟工作空間…",
      "accessCodeError": "此存取碼未獲接受。請檢查後再試。",
      "useEmailCode": "改用電子郵件驗證碼",
      "useAccessCode": "使用存取碼",
      "openTill": "開啟此收銀台",
      "signOut": "登出",
      "signingOut": "正在登出…",
      "signOutError": "無法將你登出。離開此裝置前請重試。",
      "emailOtpSubject": "您的 Collectie 登入驗證碼",
      "emailOtpLead": "您的 Collectie 登入驗證碼是 {code}。",
      "emailOtpExpiry": "驗證碼會在 5 分鐘後失效。",
      "emailOtpIgnore": "若您未要求此驗證碼，可以忽略這封電子郵件。"
    },
    "operator": {
      "eyebrow": "試點營運",
      "title": "新增商店",
      "body": "透過一次可稽核操作建立商家、首間分店及店主登入權限。店主登入後再設定會員獎賞計畫。",
      "accessEyebrow": "受保護操作",
      "accessTitle": "營運人員權限",
      "accessBody": "請使用發給已核准 Collectie 營運人員的測試或正式環境金鑰。金鑰只會隨此次要求傳送，瀏覽器不會儲存。",
      "operatorKey": "營運人員新增商家金鑰",
      "shopEyebrow": "商家身分",
      "shopTitle": "商店資料",
      "merchantNameEn": "商店名稱 — 英文",
      "merchantNameZhHant": "商店名稱 — 繁體中文（選填）",
      "legalName": "法定名稱",
      "merchantSlug": "商家網址代稱",
      "currency": "貨幣代碼",
      "category": "探索分類",
      "categoryCafeTea": "咖啡與茶",
      "categoryFood": "餐飲",
      "categoryShops": "商店",
      "ownerEyebrow": "帳戶店主",
      "ownerTitle": "店主登入權限",
      "ownerName": "店主姓名",
      "ownerEmail": "店主電子郵件",
      "ownerLocale": "偏好語言",
      "locationEyebrow": "首間公開分店",
      "locationTitle": "分店及地圖資料",
      "locationNameEn": "分店名稱 — 英文",
      "locationNameZhHant": "分店名稱 — 繁體中文（選填）",
      "locationInternalName": "內部分店名稱",
      "locationSlug": "永久加入網址代稱",
      "address": "街道地址",
      "locality": "城市",
      "region": "地區（選填）",
      "postalCode": "郵政編碼",
      "countryCode": "國家代碼",
      "timezone": "時區",
      "latitude": "緯度",
      "longitude": "經度",
      "authorizationError": "營運人員金鑰不獲接受，系統沒有建立商店。",
      "submitError": "未能建立商店。請檢查所有欄位，然後重試相同要求。",
      "submitNote": "此操作會建立一間啟用商店、一名啟用店主及一間已加入座標的分店，不會發布會員獎賞計畫或增加任何價值。",
      "submit": "建立試點商店",
      "submitting": "正在建立試點商店…",
      "completeEyebrow": "商店已建立",
      "completeTitle": "可以開始店主設定",
      "completeBody": "{email} 現在可以取得安全登入驗證碼，並發布第一個會員獎賞計畫。",
      "joinUrl": "永久加入網址",
      "openSignIn": "開啟商家登入"
    },
    "shell": {
      "loading": "正在恢復你的安全登入狀態…",
      "connectionLabel": "連線",
      "unavailableTitle": "無法載入你的工作空間",
      "unavailableBody": "系統沒有作出任何變更。請檢查網路連線後重試。",
      "managementNavigation": "商家管理",
      "backToOverview": "返回總覽",
      "locationCount": "啟用分店：{count}",
      "sectionPending": "此管理區域將於下一個精簡功能階段推出。你現有的商家資料維持不變。"
    },
    "nav": {
      "overview": "首頁",
      "program": "會員獎賞",
      "shop": "商店資料",
      "locations": "分店",
      "staff": "團隊與收銀台",
      "transactions": "活動紀錄",
      "campaigns": "推廣活動",
      "settings": "設定",
      "scanner": "掃描器",
      "dashboard": "總覽",
      "activity": "交易"
    },
    "overview": {
      "welcome": "歡迎回來，{name}",
      "title": "今日概況",
      "transactions": "交易",
      "newMembers": "新會員",
      "rewardsRedeemed": "已兌換獎賞",
      "appBoosts": "App 加碼印花",
      "recent": "最近紀錄"
    },
    "pageDescription": {
      "overview": "清楚查看今天的營運、會員獎賞計畫，以及需要處理的事項。",
      "transactions": "查看已核實的結帳活動，並更正符合資格的交易。",
      "program": "設定顧客在每間分店看到的會員獎賞體驗。",
      "shop": "讓加入頁面、Wallet 及 Collectie App 都一致呈現你的商店品牌。",
      "locations": "管理分店資料，以及用作加入會員的公開 QR Code。",
      "staff": "管理可進入後台的人員，以及可執行結帳的收銀台。"
    },
    "till": {
      "open": "開啟收銀台",
      "openHint": "共用結帳",
      "checkingDevice": "正在檢查收銀台",
      "sharedCounter": "匿名共用櫃台",
      "menu": "收銀台選項",
      "manageBusiness": "管理商家"
    },
    "program": {
      "title": "會員獎賞計畫",
      "draft": "草稿",
      "active": "生效中",
      "visitTemplate": "到訪印花",
      "itemTemplate": "指定類別印花",
      "threshold": "所需印花數目",
      "rewardLabel": "獎賞",
      "dailyLimit": "每日印花上限",
      "expiry": "獎賞有效期",
      "preview": "預覽顧客畫面",
      "publishConfirm": "確定發布此版本？現有交易會保留原有條款。",
      "type": "計畫類型",
      "target": "所需印花數目",
      "reward": "獎賞",
      "appBoost": "App 加碼印花",
      "appBoostDescription": "顧客啟用 App 後，在下一次已核實消費額外增加一個印花。",
      "templateHeading": "選擇安全範本",
      "visitHelp": "按已核實的合資格到訪發放印花。",
      "itemHelp": "只為受控的指定類別發放印花。",
      "englishContent": "英文內容",
      "chineseContent": "繁體中文內容",
      "optional": "選填",
      "name": "計畫名稱",
      "description": "簡介",
      "terms": "條款",
      "itemGroups": "合資格商品類別",
      "addItemGroup": "新增商品類別",
      "itemKey": "內部識別碼",
      "itemEnglish": "英文標籤",
      "itemChinese": "繁體中文標籤",
      "removeItemGroup": "移除商品類別",
      "fallbackPreview": "英文後備內容",
      "fallbackWarning": "繁體中文內容為空，將會向顧客顯示英文。",
      "history": "版本紀錄",
      "version": "版本 {version}",
      "publishedThreshold": "已發布的印花門檻",
      "noHistory": "尚未發布任何版本。",
      "previewName": "未命名計畫",
      "loading": "正在載入計畫草稿…",
      "loadError": "無法載入此計畫，系統沒有作出任何變更。",
      "permissionTitle": "無法使用計畫管理",
      "permissionBody": "必須由店主或具全域權限的經理管理此計畫。",
      "unsaved": "尚未儲存的變更",
      "saving": "正在儲存…",
      "saved": "草稿已儲存。",
      "published": "新的不可變版本已生效。",
      "saveError": "未能儲存草稿。請檢查欄位後重試。",
      "publishError": "無法發布草稿。請重新載入草稿後再試。",
      "publishTitle": "發布新版本？",
      "validationRequired": "此欄位為必填。",
      "validationFormat": "請使用指定的安全格式。",
      "validationDuplicate": "此值必須是唯一的。",
      "validationLength": "此內容過長。",
      "validationRange": "請輸入允許範圍內的數值。"
    },
    "scanner": {
      "title": "掃描顧客會員卡",
      "ready": "準備掃描",
      "cameraHelp": "請將 Collectie 條碼放在框內。",
      "addStamp": "增加 1 個印花",
      "redeem": "兌換獎賞",
      "success": "交易完成",
      "duplicate": "此交易已完成，現正顯示原有結果。",
      "permissionTitle": "需要相機權限",
      "permissionBody": "請在瀏覽器設定允許相機，或使用獲准的支援後備方式。",
      "offlineTitle": "連線中斷",
      "offlineBody": "未有增加任何獎賞。重新連線後請重試同一操作。",
      "start": "開啟掃描器",
      "prompt": "掃描顧客的 Collectie 會員卡",
      "hint": "請確保此裝置已配對至正確分店。店員確認操作前，系統不會建立交易。",
      "manual": "使用獲准的後備方式",
      "deviceScope": "已配對的收銀裝置",
      "deviceChecking": "正在檢查此收銀裝置…",
      "deviceCheckingBody": "只有此瀏覽器具備已配對的憑證後，才會開啟掃描器。",
      "deviceCheckError": "未能檢查此裝置",
      "pairTitle": "配對此收銀裝置",
      "pairBody": "輸入由獲授權經理建立的一次性驗證碼。裝置憑證不會向瀏覽器程式碼公開。",
      "pairingCode": "一次性配對碼",
      "pairHelp": "配對碼由 8 個英文字母或數字組成，並會在 10 分鐘後失效。",
      "pairError": "此配對碼無效、已過期或已使用。裝置尚未配對。",
      "pairing": "正在配對裝置…",
      "pairAction": "配對裝置",
      "checking": "正在檢查顧客資料",
      "noValueYet": "尚未增加任何印花或獎賞。",
      "cardUnknownTitle": "無法識別會員卡",
      "cardUnknownBody": "請顧客開啟目前的 Collectie 會員卡，然後重新掃描。",
      "quoteExpiredTitle": "確認已過期",
      "quoteExpiredBody": "尚未增加任何數值。請重新掃描顧客會員卡以取得新的確認。",
      "actionErrorTitle": "目前無法執行操作",
      "actionErrorBody": "尚未增加任何數值。請檢查會員卡及裝置後再試。",
      "scanAgain": "重新掃描",
      "confirmLabel": "確認顧客",
      "currentBalance": "目前印花結餘",
      "quoteWindow": "此確認只在短時間內有效。只有你確認後，結餘才會變更。",
      "confirmEarn": "確認增加 {quantity} 個印花",
      "committing": "正在增加印花…",
      "commitPending": "請保持此頁開啟。如需重試，系統會使用同一個安全請求。",
      "retrySameAction": "重試相同操作",
      "balanceNow": "目前有 {balance} 個印花",
      "earnedReceipt": "已從權威帳本增加 {quantity} 個印花。",
      "earnedRewardReceipt": "已增加 {quantity} 個印花。獎賞現已解鎖，可立即使用。",
      "nextCustomer": "掃描下一位顧客",
      "cameraStarting": "正在啟動相機",
      "cameraIdle": "相機已暫停",
      "cameraUnavailableBody": "此處無法使用即時 QR 掃描。請使用獲准的後備方式完成相同的安全確認流程。",
      "enableCamera": "啟用相機",
      "manualLabel": "顧客會員卡憑證",
      "manualHelp": "只可從獲准的支援流程貼上。系統會在檢查後立即清除。",
      "checkCustomer": "檢查顧客",
      "availableRewards": "可用獎賞",
      "rewardReady": "可立即使用",
      "confirmRedeem": "確認兌換",
      "rewardStaleTitle": "獎賞狀態已變更",
      "rewardStaleBody": "尚未兌換任何獎賞。請重新掃描以載入顧客目前的獎賞。",
      "rewardRedeemed": "獎賞已兌換",
      "redeemedReceipt": "權威帳本已記錄此兌換。",
      "addStampFor": "為 {item} 加印花",
      "confirmEarnItem": "加 {quantity} 個印花 · {item}",
      "chooseItemGroup": "選擇項目",
      "dailyLimitReached": "今天在本店的 {limit} 個印花上限已用完，仍可兌換獎賞。"
    },
    "staff": {
      "title": "團隊與收銀台",
      "managementAccess": "管理權限屬於個人",
      "managementAccessBody": "店主及經理使用自己的電子郵件或存取碼登入。櫃台員工可直接使用已配對的收銀台，不需要進入管理後台。",
      "tillsEyebrow": "結帳權限",
      "tillsTitle": "已配對收銀台",
      "tillsBody": "每部收銀台都是綁定一間分店的匿名共用櫃台。每筆結帳紀錄都會顯示裝置名稱。",
      "activeCount": "{count} 部啟用中",
      "loadingDevices": "正在載入已配對收銀台…",
      "devicesError": "未能載入已配對收銀台。裝置設定沒有變更。",
      "emptyTills": "尚未配對收銀台",
      "emptyTillsBody": "在下方建立一次性驗證碼，然後在結帳裝置輸入。",
      "neverUsed": "尚未開啟",
      "lastSeen": "上次開啟：{time}",
      "status": {
        "active": "啟用中",
        "revoked": "已撤銷"
      },
      "revokeConfirm": "此收銀台會立即停止運作。",
      "revokeAction": "撤銷收銀台",
      "revokeError": "未能撤銷此收銀台，它可能仍可為顧客結帳。",
      "pairEyebrow": "新增櫃台",
      "invite": "邀請員工",
      "pair": "配對收銀裝置",
      "pairBody": "為櫃台命名並建立短效驗證碼。在裝置輸入一次後，該瀏覽器便可在所選分店執行結帳。",
      "deviceLabel": "收銀裝置名稱",
      "deviceLabelHelp": "請使用員工容易辨認的名稱，例如「前台 iPhone」。",
      "createCode": "建立一次性驗證碼",
      "creatingCode": "正在建立驗證碼…",
      "codeTitle": "一次性配對驗證碼",
      "codeBody": "在「開啟收銀台」中輸入此驗證碼一次。驗證碼會在十分鐘後失效，亦不可重用。",
      "expiresAt": "有效至 {time}",
      "copyCode": "複製驗證碼",
      "copied": "已複製驗證碼",
      "generateAnother": "建立另一個驗證碼",
      "createError": "未能建立驗證碼，亦未配對任何裝置。請檢查分店後再試。",
      "noLocations": "請先新增或啟用分店，然後才配對收銀裝置。",
      "revoke": "撤銷",
      "owner": "店主",
      "manager": "經理",
      "cashier": "店員"
    },
    "dashboard": {
      "title": "總覽",
      "statusLabel": "商家狀態",
      "glance": "今日概況",
      "todayTransactions": "今日交易",
      "activeMembers": "活躍會員",
      "rewardsRedeemed": "已兌換獎賞",
      "programLive": "已發布，所有啟用分店均可累積印花。",
      "recent": "最近紀錄",
      "loading": "正在載入今日總覽…",
      "errorTitle": "未能載入總覽",
      "errorBody": "系統沒有更改任何資料。請檢查網路連線後再試。",
      "permissionTitle": "無法查看總覽",
      "permissionBody": "你目前的商家角色無權查看此總覽。",
      "localToday": "按分店當地日期計算",
      "serverTruth": "伺服器上的有效紀錄",
      "programPublished": "已發布計畫",
      "programDraft": "計畫設定",
      "checkoutReady": "可開始結帳",
      "setupRequired": "需要完成設定",
      "programNotPublished": "發布第一個獎賞計畫",
      "programThreshold": "集滿 {threshold} 個；{active} 間啟用分店中有 {ready} 間已可公開加入。",
      "publishPrompt": "展示公開加入 QR Code 前，請完成並發布獎賞計畫。",
      "emptyTitle": "尚未有已核實紀錄",
      "emptyBody": "已確認的結帳事件會顯示於此。"
    },
    "shop": {
      "title": "商店資料",
      "loading": "正在載入商店資料…",
      "errorTitle": "未能載入商店資料",
      "errorBody": "系統沒有更改任何商店資料。請檢查網路連線後再試。",
      "permissionTitle": "無法查看商店資料",
      "permissionBody": "你目前的商家角色無權查看此商店資料。",
      "identityEyebrow": "顧客可見的品牌",
      "identityTitle": "讓顧客一眼認出你的商店",
      "identityBody": "顧客加入會員、開啟會員卡或在 Collectie 探索商店時，都會看到這些資料。",
      "chooseLogo": "選擇標誌",
      "logoHelp": "支援 PNG、JPEG 或 WebP。正方形圖像效果最佳，上限為 512 KB。",
      "logoSave": "上載此標誌",
      "logoSaving": "正在上載標誌…",
      "logoError": "未能上載標誌。請檢查檔案格式及大小後再試。",
      "english": "英文",
      "traditionalChinese": "繁體中文（選填）",
      "displayName": "商店名稱",
      "description": "簡短介紹",
      "category": "商店類別",
      "categories": {
        "cafe_tea": "咖啡與茶飲",
        "food": "餐飲",
        "shops": "零售商店"
      },
      "website": "網站（選填）",
      "brandColor": "品牌顏色",
      "customerPreview": "顧客預覽",
      "previewFallback": "你的商店",
      "previewDescriptionFallback": "簡短介紹可幫助顧客辨認這張會員卡。",
      "previewWallet": "加入 Apple Wallet",
      "previewSurfaces": "此預覽顯示加入頁面及 Collectie App 使用的品牌。Wallet 版面會依照 Apple 的票證格式呈現。",
      "qrEyebrow": "公開加入 QR Code",
      "qrTitle": "保留特色，同時確保容易掃描",
      "qrBody": "永久目的地不會改變，所有分店 QR Code 都會套用這個樣式。",
      "qrPreviewAlt": "自訂公開加入 QR Code 預覽",
      "qrPreviewError": "此顏色組合不適合可靠掃描。請提高對比度，並使用較深的前景色。",
      "qrForeground": "QR Code 顏色",
      "qrBackground": "背景顏色",
      "qrShape": "圖點形狀",
      "qrStyles": {
        "square": "方形",
        "rounded": "圓角",
        "dots": "圓點"
      },
      "qrLogo": "在中央顯示標誌",
      "qrLogoHelp": "上載標誌後即可使用。",
      "qrGuardrail": "Collectie 會保留靜區、高對比度、高級錯誤修正及受限的標誌範圍，讓 QR Code 維持可靠。",
      "validation": "請檢查必填的英文名稱、HTTPS 網站、商店介紹及適合掃描的 QR Code 顏色。",
      "saveError": "未能儲存商店資料，亦沒有套用狀態不明的變更。重新連線後請再試。",
      "readOnly": "只有店主及經理可以修改商店資料。",
      "saving": "正在儲存商店資料…",
      "save": "儲存商店資料",
      "saved": "商店資料已儲存，顧客介面將使用新的品牌。"
    },
    "locations": {
      "eyebrow": "商店分店",
      "title": "分店及公開 QR Code",
      "body": "每間分店都有一個永久公開加入 QR Code，可下載後放在櫃台、櫥窗、餐牌或印刷品上。",
      "loading": "正在載入分店…",
      "errorTitle": "未能載入分店",
      "errorBody": "系統沒有更改任何分店。請檢查網路連線後再試。",
      "permissionTitle": "無法查看分店",
      "permissionBody": "你目前的商家角色無權查看這些分店。",
      "add": "新增分店",
      "newEyebrow": "新增試點分店",
      "newTitle": "分店資料",
      "internalName": "內部名稱",
      "slug": "永久網址識別碼",
      "displayNameEn": "顯示名稱 — 英文",
      "displayNameZhHant": "顯示名稱 — 繁體中文（選填）",
      "addressLine1": "街道地址",
      "addressLine2": "地址第二行（選填）",
      "locality": "城市",
      "region": "地區（選填）",
      "postalCode": "郵政編碼",
      "countryCode": "國家代碼",
      "timezone": "時區",
      "latitude": "緯度",
      "longitude": "經度",
      "coordinate": "地圖座標",
      "coordinateHelp": "座標會用於日後的地圖檢視，不會授予交易權限。",
      "validation": "請檢查網址識別碼、地址、座標及必填的英文顯示名稱。",
      "conflict": "此分店或網址已存在，系統沒有建立任何資料。",
      "saveError": "結果尚未確定。重新連線後請重試相同的分店請求。",
      "retrySame": "重試相同分店",
      "saving": "正在建立分店…",
      "save": "建立分店",
      "created": "分店已建立，並附有可審計的永久加入網址。",
      "emptyTitle": "尚未有分店",
      "emptyBody": "新增第一間試點分店，以準備永久公開加入網址。",
      "qrTitle": "永久公開 QR Code",
      "publicReady": "公開加入已準備好",
      "publicPending": "展示此 QR Code 前請先發布計畫",
      "qrSafety": "此 QR Code 只會開啟公開加入流程，不能增加印花或兌換獎賞。",
      "customizeQr": "自訂樣式",
      "qrPreviewAlt": "{name} 的公開加入 QR Code",
      "qrPreviewLoading": "正在準備 QR Code…",
      "downloadQr": "下載 QR Code",
      "qrError": "未能下載 QR Code，請再試一次。",
      "status": {
        "draft": "草稿",
        "active": "啟用",
        "suspended": "已暫停",
        "closed": "已關閉"
      }
    },
    "activity": {
      "title": "交易紀錄",
      "recent": "最近交易",
      "loading": "正在載入交易紀錄…",
      "loadErrorTitle": "未能載入交易紀錄",
      "loadErrorBody": "系統沒有更改任何紀錄。請檢查網路連線後再試。",
      "permissionTitle": "無法查看交易紀錄",
      "permissionBody": "你目前的商家角色無權查看此交易紀錄。",
      "emptyTitle": "尚未有交易紀錄",
      "emptyBody": "已核實的結帳事件會顯示於此。",
      "count": "{count} 項紀錄",
      "rewardEffect": "獎賞",
      "details": "審計詳情",
      "actor": "操作來源",
      "device": "收銀裝置",
      "requestId": "請求識別碼",
      "sharedTillActor": "共用收銀台",
      "systemActor": "Collectie 系統",
      "reverses": "撤銷交易",
      "reversedBy": "由此交易撤銷",
      "reverseAction": "撤銷交易",
      "reversalReason": "撤銷原因",
      "reversalWarning": "系統會建立相連的補償帳本紀錄，不會刪除原有交易。",
      "confirmReversal": "確認撤銷",
      "reversing": "正在建立補償紀錄…",
      "reversalComplete": "交易已撤銷，並已建立相連的補償紀錄。",
      "reversalForbidden": "你的角色無權撤銷此交易。",
      "reversalConflict": "此交易已不可撤銷，交易紀錄沒有變更。",
      "reversalOffline": "結果尚未確定。重新連線後請重試相同的撤銷操作。",
      "reversalError": "未能完成撤銷。請重試相同操作。",
      "retryReversal": "重試相同撤銷",
      "loadMore": "載入較早紀錄",
      "loadingMore": "正在載入較早紀錄…",
      "action": {
        "earn": "獲得印花",
        "redeem": "兌換獎賞",
        "adjust": "調整",
        "expire": "到期",
        "reverse": "撤銷紀錄"
      },
      "status": {
        "committed": "已完成",
        "reversed": "已撤銷",
        "voided": "已作廢"
      },
      "reason": {
        "cashier_mistake": "店員操作錯誤",
        "refund": "退款",
        "duplicate": "重複交易",
        "customer_dispute": "顧客爭議",
        "operator_correction": "營運人員更正"
      }
    }
  },
  "transaction": {
    "quoteExpired": "此操作已逾時，請重新掃描會員卡。",
    "cardUnknown": "無法讀取此 Collectie 會員卡。",
    "cardRevoked": "此會員卡已更換或撤銷。",
    "rewardUnavailable": "此獎賞已不再可用。",
    "reversalReason": "撤銷原因",
    "reversed": "交易已撤銷。",
    "walletDelayed": "交易已完成，Wallet 會員卡可能需要片刻才會更新。",
    "dailyLimitReached": "此顧客今天在本店已達印花上限。"
  },
  "errors": {
    "generic": "發生錯誤。",
    "unauthorized": "登入已過期，請重新登入。",
    "forbidden": "你沒有權限執行此操作。",
    "network": "請檢查網路連線後再試。",
    "validation": "請檢查標示的欄位。",
    "idempotencyMismatch": "此次重試與原本要求不一致。",
    "rateLimited": "嘗試次數過多，請稍後再試。"
  },
  "language": {
    "english": "English",
    "traditionalChinese": "繁體中文",
    "german": "德文",
    "choose": "語言",
    "current": "語言：{language}"
  },
  "demo": {
    "reward": {
      "freeDrink": "一杯價值不超過 €5 的飲品"
    },
    "program": {
      "coffeeClub": "咖啡印花卡",
      "lunchCircle": "午餐獎賞卡"
    },
    "category": {
      "coffee": "咖啡",
      "food": "餐飲",
      "shops": "商店"
    },
    "activity": {
      "earn": "已獲得印花",
      "bonus": "已套用 App 加碼印花",
      "reward": "已解鎖獎賞",
      "redeem": "已兌換獎賞"
    },
    "time": {
      "today1432": "今天 · 14:32",
      "yesterday1208": "昨天 · 12:08",
      "jul221744": "7 月 22 日 · 17:44"
    }
  },
  "accessibility": {
    "stampCollected": "已收集印花",
    "stampEmpty": "未收集印花"
  },
  "official": {
    "meta": {
      "title": "Collectie — 把來客變成熟客",
      "description": "為餐廳、零售與商場打造的會員經營平台。顧客用 Apple Wallet 幾秒加入，免 App、免電子郵件、免留個資，讓你在尊重顧客隱私的同時，好好經營顧客關係與回訪。",
      "imageAlt": "Collectie 協助餐廳、零售與商場把第一次來訪的顧客變成常回來的熟客。"
    },
    "analytics": {
      "label": "選用的網站分析",
      "title": "協助我們改善網站。",
      "body": "取得您的同意後，Google Analytics 會衡量頁面造訪情形，協助我們改善本網站。我們不會傳送表單內容、網址查詢參數、帳號資料或廣告訊號；在您允許前，網站分析會維持關閉。",
      "accept": "允許網站分析",
      "reject": "維持關閉",
      "privacy": "閱讀隱私權聲明",
      "settings": "網站分析設定",
      "statusGranted": "網站分析目前已開啟。",
      "statusDenied": "網站分析目前已關閉。"
    },
    "nav": {
      "product": "會員經營",
      "platform": "完整平台",
      "pricing": "收費方式",
      "contact": "與我們談談",
      "primary": "主要導覽",
      "open": "開啟選單",
      "close": "關閉選單",
      "home": "Collectie 首頁"
    },
    "hero": {
      "eyebrow": "為每一間店打造的會員經營平台",
      "titleLead": "把第一次來的客人，",
      "titleAccent": "變成常回來的熟客。",
      "lede": "Collectie 是為餐廳、咖啡廳、零售與商場打造的會員經營平台。顧客用 Apple Wallet 幾秒加入，免 App、免電子郵件、免留個資；你不必蒐集任何會讓顧客不安的資料，就能經營顧客關係、帶動回訪與營收。",
      "primary": "了解會員經營",
      "secondary": "查看完整平台",
      "artLabel": "俯視店家營運地圖，連結顧客旅程、內場、櫃檯與後台",
      "artCore": "你的店",
      "artOrbit": "8 個獨立模組",
      "scroll": "繼續探索完整平台"
    },
    "principle": {
      "eyebrow": "先從會員經營開始，其他功能需要時再加",
      "title": "更懂你的顧客，讓他們一再回來。",
      "body": "先用一套任何店家一天內就能上線的會員計畫，之後再視需要加入點餐、收款、餐桌、庫存等模組。所有功能都圍繞同一件事：更了解你的顧客，並給他們一個回來的理由。",
      "keep": "一天內就能開始",
      "keepBody": "為一間店啟用會員計畫，不必更換你現有的系統。",
      "hardware": "認識你的熟客",
      "hardwareBody": "看見誰常回來、多久來一次、喜歡什麼——而且完全不必保存他們的個資。",
      "pace": "用看得見的資料經營",
      "paceBody": "把每一次來訪，變成團隊可以行動的訊號，持續帶動回訪與熟客。"
    },
    "restaurantScene": {
      "eyebrow": "貼近店家真實的一天",
      "title": "每一次來訪，都是經營關係的機會。",
      "body": "客人上門、點餐、結帳、離開——有了 Collectie，這一次來訪會悄悄成為長期關係的一部分。不論你經營的是餐廳、咖啡廳，還是商場裡的專櫃，節奏都一樣，團隊也不必為了配合軟體改變做事方式。",
      "guest": "顧客與前場",
      "kitchen": "服務與庫存",
      "supply": "收貨與供應",
      "alt": "以像素藝術呈現一間社區餐廳晚餐時段的等距剖面，包括用餐區、吧台、廚房、庫存及正在到貨的配送",
      "caption": "插畫概念 · 以顧客為核心的店家經營"
    },
    "loyalty": {
      "eyebrow": "首個產品 · 會員經營",
      "title": "幾秒加入的會員計畫，不必留下任何個資。",
      "body": "顧客掃描店內 QR Code，把 Collectie 會員卡加入 Apple Wallet 就完成。不必註冊、不必下載 App，也不用留電子郵件或電話。你能穩定累積熟客，卻不必蒐集任何需要保護的個資。",
      "wallet": "免 App，免留個資",
      "walletBody": "顧客直接從 Apple Wallet 加入，不需要電子郵件、電話或帳戶。",
      "checkout": "結帳時掃描一次",
      "checkoutBody": "店員掃描顧客的會員卡、確認這次來訪，互動就這麼簡單。",
      "truth": "隱私，內建保護",
      "truthBody": "獎賞累積在一張匿名會員卡上，而不是某個人身上——沒有任何顧客會猶豫提供的資料。",
      "cardProgram": "熟客計畫",
      "cardReward": "下一份獎賞",
      "cardRewardValue": "招牌甜品",
      "cardProgress": "已到訪 5 / 7 次",
      "cardMember": "會員 284 916",
      "cardHint": "結帳時掃描",
      "flowJoin": "加入",
      "flowJoinBody": "客人掃描店內 QR Code",
      "flowCollect": "累積",
      "flowCollectBody": "店員確認這次來訪",
      "flowReturn": "再訪",
      "flowReturnBody": "獎賞帶客人再次回來"
    },
    "platform": {
      "eyebrow": "依你的步調逐步擴充",
      "title": "先做會員經營，其他功能準備好再加。",
      "body": "先用每間店都能上手的會員計畫，之後再逐步加入點餐、收款、餐桌、庫存與供應商。當這些模組串連起來，每一次來訪都會讓你更了解顧客，幫你把他們留下來。會員經營率先推出；以下其他模組仍在規劃中。",
      "core": "Collectie Intelligence",
      "coreBody": "當模組串連後，AI 輔助核心會把日常營運變成簡單的建議——哪些熟客正在流失、該補什麼貨、下一步可以試什麼。它只提供建議，決定權仍在你的團隊手上。",
      "intelligenceEyebrow": "AI 輔助平台核心 · 規劃中",
      "intelligenceMark": "AI",
      "intelligenceForecast": "預測需求",
      "intelligenceException": "看見變化",
      "intelligenceAction": "建議下一步",
      "intelligenceGuard": "所有重要動作都由團隊審核後執行。",
      "select": "選擇模組了解更多",
      "first": "率先推出",
      "planned": "規劃中",
      "pricingBasis": "計價基準",
      "loyalty": {
        "name": "會員經營",
        "tagline": "把第一次來的客人，變成回頭的熟客。",
        "body": "Apple Wallet 會員卡、到訪印花與獎賞，不需要顧客下載 App、也不需要個資。規則由你設定，熟客自然回流。",
        "price": "按啟用分店"
      },
      "pos": {
        "name": "POS 與 Tap to Pay",
        "tagline": "用你現有的手機或平板收款。",
        "body": "規劃中的 Tap to Pay、付款與收據功能，並與每一次顧客來訪連動。",
        "price": "平台費用與付款交易量"
      },
      "orders": {
        "name": "點餐",
        "tagline": "把所有訂單集中在同一處。",
        "body": "規劃中的櫃檯、餐桌與線上點餐管理，餐廳與零售都適用。",
        "price": "按啟用分店"
      },
      "tables": {
        "name": "餐桌管理",
        "tagline": "一眼掌握每張餐桌的狀況。",
        "body": "規劃中的即時桌況、用餐人數與服務交接資訊，協助前場團隊安排工作。",
        "price": "按啟用分店"
      },
      "reservations": {
        "name": "訂位",
        "tagline": "客人抵達前，先做好準備。",
        "body": "規劃中的訂位功能，可連結到訪紀錄與服務備註，隱私控制權掌握在你手上。",
        "price": "按可訂位分店"
      },
      "inventory": {
        "name": "庫存",
        "tagline": "答應客人前，先確認還有哪些品項。",
        "body": "規劃中的商品與餐點供應狀態，會隨日常營運自動更新。",
        "price": "按庫存地點"
      },
      "supply": {
        "name": "採購與供應商",
        "tagline": "在需要的時間，向合適的供應商補貨。",
        "body": "規劃中的採購功能，涵蓋低庫存提醒、供應商價格、採購單與收貨紀錄。",
        "price": "按分店及採購量"
      },
      "invoice": {
        "name": "發票",
        "tagline": "直接從每筆交易開立合規發票。",
        "body": "規劃中的發票功能，依各地法規調整，並直接與結帳流程連接。",
        "price": "依地區與發票張數"
      }
    },
    "pricing": {
      "eyebrow": "簡單、透明的收費",
      "title": "從會員經營開始，只為用到的功能付費。",
      "body": "先啟用會員計畫，之後再依需要加入其他模組。每個模組都有清楚、獨立的計價方式，不需要為尚未使用的功能付費。",
      "loyaltyLabel": "起點",
      "loyaltyTitle": "Collectie 會員經營",
      "loyaltyBody": "首批參與地區試點的店家可使用創始合作夥伴方案，正式公開價格將於日後公布。",
      "includedOne": "Apple Wallet 會員卡與固定店內 QR Code",
      "includedTwo": "店員掃描器、獎賞與到訪紀錄——不含任何顧客個資",
      "includedThree": "每間啟用分店的計畫設定",
      "founding": "創始合作夥伴方案",
      "cta": "談談你的店",
      "modelLabel": "未來模組的計價方式",
      "modelTitle": "每個模組都有自己的計價方式。",
      "modelBody": "啟用前，你會清楚看到該模組如何收費，例如按分店、使用量、交易金額或發票張數計價。",
      "note": "規劃中的模組代表產品藍圖；正式推出前，推出時間、功能與價格仍可能調整。"
    },
    "contact": {
      "eyebrow": "告訴我們你的店",
      "title": "先從會員經營開始，也可以一起規劃完整平台。",
      "body": "告訴我們你最想改善什麼。我們可以先介紹目前的會員經營，也可以一起討論其他模組未來如何配合你的餐廳、門市或商場。",
      "restaurant": "店家名稱",
      "restaurantPlaceholder": "例如：花見小館",
      "email": "工作用電子郵件",
      "emailPlaceholder": "you@yourstore.com",
      "city": "城市",
      "cityPlaceholder": "你的店在哪裡？",
      "interest": "你想先了解什麼？",
      "interestLoyalty": "推出會員經營",
      "interestPlatform": "探索完整平台",
      "interestPilot": "加入地區試點",
      "submit": "預約產品介紹",
      "submitting": "正在傳送需求…",
      "privacy": "我們只會使用這些資料回覆您的需求，並於 180 天後自動刪除這筆洽詢紀錄。",
      "privacyLink": "閱讀隱私權聲明",
      "required": "請填寫店家名稱。",
      "restaurantTooLong": "店家名稱請勿超過 120 個字元。",
      "emailRequired": "請填寫工作用電子郵件。",
      "emailInvalid": "請輸入有效的電子郵件地址。",
      "emailTooLong": "電子郵件地址請勿超過 254 個字元。",
      "cityRequired": "請填寫城市。",
      "cityTooLong": "城市名稱請勿超過 120 個字元。",
      "submitError": "目前無法儲存您的需求。請檢查網路連線後再試一次。",
      "rateLimited": "此網路連線送出的需求過多，請在一小時後再試。",
      "readyTitle": "已收到您的需求。",
      "readyBody": "我們已安全儲存這筆洽詢，Collectie 團隊可透過您的工作信箱與您聯絡。",
      "again": "再送出一筆需求"
    },
    "footer": {
      "statement": "經營長久的顧客關係，不必蒐集需要保護的個資。",
      "availability": "會員經營率先推出 · 其他模組開發中",
      "privacy": "隱私權",
      "support": "支援",
      "terms": "使用條款",
      "copyright": "© {year} Collectie"
    },
    "privacy": {
      "metaTitle": "隱私權 — Collectie",
      "metaDescription": "了解 Collectie 如何在 App、Apple 錢包、商家工具與官方網站中處理個人資料。",
      "skip": "跳至隱私權聲明",
      "eyebrow": "隱私權 · 歐盟／歐洲經濟區與台灣",
      "title": "您的集點紀錄，應由您掌握。",
      "lede": "本聲明說明 Collectie 蒐集哪些資料、為何需要、可能提供給誰，以及您可以如何選擇與行使權利。",
      "factsLabel": "隱私權聲明資訊",
      "controllerLabel": "資料控制者",
      "controllerName": "Collectie",
      "updatedLabel": "生效日期",
      "updatedDate": "2026 年 8 月 26 日",
      "contactLabel": "隱私權聯絡信箱",
      "tocLabel": "本聲明內容",
      "summaryLabel": "重點摘要",
      "summaryBody": "Collectie 不販售個人資料、不投放第三方廣告，也不跨 App 或網站追蹤使用者。我們只使用維持各商家獨立獎賞、保護帳號及更新 Apple 錢包票卡所需的最少資料。",
      "emailAction": "詢問隱私權問題",
      "sections": {
        "scope": {
          "title": "本聲明適用對象與範圍",
          "body": "Collectie 是透過 Collectie 顧客 App、Apple 錢包票卡、公開會員頁面、商家管理與櫃台工具、官方網站及客服所處理個人資料的資料控制者。",
          "coverage": "參與商家若為其會員條款、顧客服務、會計或法定紀錄自行決定資料用途，可能另為該資料的控制者。商家決定如何使用資料時，請向該商家確認其隱私權做法。"
        },
        "data": {
          "title": "我們處理的資料",
          "intro": "實際涉及的資料取決於您如何使用 Collectie：",
          "identity": "會員與帳號資料：不具直接識別性的個人、票卡與會員識別碼、顯示用會員代碼、語言，以及帳號、憑證或票卡狀態。顧客不必先提供電子郵件即可取得 Apple 錢包票卡。",
          "loyalty": "集點活動資料：商家與分店會員關係、造訪、購買、集點進度、獎賞、調整、沖銷及到期紀錄，並記錄於不可竄改的帳本。預設不蒐集完整購物明細；只有經核准的集點規則確有需要時，才會保留消費金額或品項群組。",
          "wallet": "Apple 錢包資料：票卡類型與序號識別碼、受保護的票卡驗證憑證、裝置資料庫識別碼、Apple 推播權杖，以及票卡建立或更新狀態。",
          "merchant": "商家營運資料：已授權商家使用者的姓名、工作信箱、角色、工作階段與裝置資訊，以及商家、分店和集點方案設定。",
          "technical": "技術與安全資料：IP 位址與一般請求中繼資料、請求識別碼、裝置或 App 版本，以及安全與診斷事件。應用程式紀錄會遮蔽憑證、一次性驗證碼、Apple 身分權杖與票卡驗證憑證。",
          "support": "客服資料：您選擇傳送給我們的訊息與附件內容，以及調查問題所需的相關資訊。",
          "website": "網站資料：洽詢內容包括餐廳名稱、工作信箱、城市、感興趣的項目、介面語言、送出時間及通知狀態。防濫用機制只儲存來源 IP 的加密雜湊值，不儲存原始 IP 位址。另外，若您允許網站分析，Google Analytics 會接收移除查詢參數與片段的頁面路徑及參照網址、頁面標題、介面語言、一般瀏覽器與裝置資訊、傳輸過程中的 IP 位址，以及使用假名的 Cookie 識別碼。表單內容與帳號識別碼絕不會傳送至 Analytics。",
          "minimization": "本服務不蒐集付款卡資料、健康資料、聯絡人或廣告識別碼。選用的定位權限只在您的裝置上計算距離，不會傳送至 Collectie 的 API。"
        },
        "uses": {
          "title": "資料使用目的",
          "intro": "Collectie 僅基於下列目的使用個人資料：",
          "service": "提供會員服務、顯示由伺服器管理的餘額、處理已驗證的集點與兌換活動，以及顯示交易紀錄。",
          "wallet": "建立、簽署、交付及更新 Apple 錢包票卡，並在票卡可更新時通知已註冊裝置。",
          "security": "驗證顧客與商家人員、防止濫用與重複寫入、調查詐欺、維持稽核紀錄及處理服務失敗後的資料一致性。",
          "support": "回覆客服需求、在可行範圍內協助恢復存取，並處理隱私權請求。",
          "contact": "接收網站洽詢、通知 Collectie 團隊，並透過餐廳提供的工作信箱回覆。除非另有合法依據，網站洽詢不會自動加入行銷名單。",
          "legal": "履行法律、會計及主管機關要求，並建立、行使或防禦法律請求。",
          "improve": "以彙總且低基數的營運指標監控可靠度並改善服務，不建立廣告輪廓。取得同意後，我們會衡量官方網站的頁面造訪情形，以了解哪些公開資訊最有幫助。"
        },
        "bases": {
          "title": "處理的法律依據",
          "intro": "針對歐盟或歐洲經濟區使用者，我們會依不同活動採用下列法律依據：",
          "contract": "契約：提供您要求的會員、Apple 錢包票卡、帳號或商家服務，以及在締約前依您的要求採取必要措施。",
          "legitimate": "合法利益：在衡量您的權利後，用於安全且可靠地營運 Collectie、防止濫用、支援使用者及了解服務效能。",
          "obligation": "法律義務：於適用法律、會計規範或有效主管機關要求時，保存或揭露相關紀錄。",
          "consent": "同意：用於選用的網站分析、裝置定位及依法需要同意的選用通訊。您可隨時撤回同意，但不影響撤回前處理的合法性。",
          "taiwan": "在台灣，我們基於與您的契約或類似關係、於法律要求時取得同意，並依《個人資料保護法》所允許的必要營業目的處理資料。建立或恢復帳號及運作獎賞需要必要的識別資料；若服務提供僅瀏覽模式，您可以不建立帳號直接瀏覽。"
        },
        "sharing": {
          "title": "資料提供對象",
          "intro": "我們只在提供服務或法律要求的必要範圍內揭露資料：",
          "merchants": "參與商家只會收到自己顧客與分店的活動資料。商家無法透過 Collectie 查看其他商家的顧客活動。",
          "cloudflare": "Cloudflare 提供網站託管、應用程式執行環境、資料庫、物件儲存、佇列與服務信件基礎設施。",
          "apple": "Apple 提供 App Store、Apple 錢包、Apple 推播通知服務及 MapKit。Apple 對其處理活動適用自己的條款與隱私權政策。",
          "google": "Google 為官方網站提供選用的 Google Analytics 服務。只有在您允許網站分析後，Analytics 標籤才會載入並接收頁面造訪資料；Google 廣告訊號與個人化功能會維持關閉。",
          "law": "若為遵守法律、保護個人或服務安全，或處理法律請求而合理必要時，我們可能向主管機關、顧問或相關當事人提供資訊。",
          "change": "若 Collectie 進行重組、融資、出售或合併，相關資訊可能隨業務移轉，並於法律要求時採取適當保護與通知。",
          "noSale": "我們不販售或出租個人資料、不在不同商家間分享資料以投放廣告，也不允許第三方廣告或跨 App 追蹤。"
        },
        "transfers": {
          "title": "跨境傳輸",
          "body": "Collectie 使用全球性服務供應商。我們的主要 Cloudflare D1 資料庫設定於西歐；Cloudflare、Apple，以及您同意網站分析時的 Google，仍可能在其營運所在的其他國家處理或傳輸資料。",
          "safeguards": "從歐盟或歐洲經濟區傳輸資料而依法需要保障措施時，我們會依適足性決定、核准的契約保護或其他合法傳輸機制辦理。如需了解適用的保障措施，請與我們聯絡。"
        },
        "retention": {
          "title": "資料保存期間",
          "intro": "我們只在提供服務、維護安全、處理爭議及履行適用法律義務所需期間保存個人資料。實際期間視紀錄與用途而定：",
          "active": "您使用服務期間，或為維持會員服務正常與安全所需時，會保存有效帳號、會員、憑證與 Apple 錢包紀錄。",
          "deletion": "帳號刪除完成後，Collectie 會撤銷憑證、關閉會員與帳號、移除已儲存的 Apple 錢包票卡套件，並對可直接連結帳號的識別資料進行假名化，使一般營運無法再以其識別已刪除的使用者。",
          "records": "若為維持餘額完整性、防止詐欺、解決爭議或履行法律義務所需，交易、不可竄改帳本及稽核紀錄可能在帳號刪除後繼續保存。上述目的不再需要時，我們會刪除或匿名化。",
          "support": "客服訊息會保留至問題解決，並於安全、爭議或法令遵循合理需要的額外期間保存，之後刪除或匿名化。",
          "analytics": "網站會保留您的網站分析選擇，直到您變更選擇或清除網站資料。若您允許網站分析，Collectie 設定的 Google Analytics Cookie 最晚會在首次設定後 90 天到期，且不會因日後載入頁面而延長。Analytics 事件資料依該 Analytics 資源所設定的保留控制保存，資料不再需要時會刪除或匿名化。",
          "websiteLeads": "網站洽詢及其通知紀錄會在送出 180 天後自動刪除。若洽詢轉為客戶關係，必要資料會移至相關客戶紀錄，並適用該紀錄的保存規則。"
        },
        "choices": {
          "title": "您的選擇",
          "intro": "您可控制服務的多個部分：",
          "account": "在有提供的情況下使用僅瀏覽模式、於 App 管理帳號資料，或從「個人檔案 → 隱私權與資料」開始刪除帳號。",
          "location": "拒絕選用的定位權限。您將無法計算距離，但會員與獎賞仍可正常使用。",
          "wallet": "您可隨時從 Apple 錢包移除票卡。移除票卡本身不會刪除 Collectie 帳號或集點紀錄；如要刪除，請使用 App 內的刪除功能或聯絡我們。",
          "website": "官方網站會將您選擇的語言與網站分析設定儲存在瀏覽器本機。在您允許前，Google Analytics 會維持關閉且不會載入其標籤。您可隨時使用頁尾的「網站分析設定」允許或撤回網站分析；撤回時會移除 Collectie 的 Analytics Cookie。聯絡表單資料為選填，您也可以直接寄信給客服。您可在瀏覽器設定中清除本機偏好。",
          "marketing": "Collectie 目前不寄送消費者行銷訊息。日後若有變更，選用訊息將提供法律要求的同意與退訂控制。"
        },
        "rights": {
          "title": "您的隱私權利",
          "intro": "您的權利依居住地而異，且可能適用法律例外：",
          "eu": "歐盟／歐洲經濟區：您可請求查閱、更正、刪除、限制處理、資料可攜或提出異議；撤回同意；並向所在地資料保護主管機關申訴。",
          "taiwan": "台灣：您可依《個人資料保護法》查詢或請求閱覽、請求製給複製本、補充或更正、請求停止蒐集、處理或利用，以及請求刪除。",
          "request": "如要行使權利，請寄信至 contact@collectie.io，說明相關帳號或會員及您的請求。請勿傳送密碼、一次性驗證碼、完整 QR Code 或票卡憑證、票卡驗證憑證、API 金鑰或私密金鑰。我們可能會在處理前驗證您的身分。歐盟／歐洲經濟區請求通常在一個月內回覆；台灣請求則依適用法律規定期間辦理。",
          "complaint": "歡迎先與我們聯絡，以便調查處理。您也可以直接向所在國家或地區具管轄權的隱私或資料保護主管機關提出申訴。"
        },
        "security": {
          "title": "資料安全措施",
          "body": "我們採用傳輸加密、角色權限控管、商家租戶隔離、受保護的驗證憑證、防重複交易控制、不可竄改帳本、稽核事件及紀錄遮蔽。只有基於授權目的的人員可存取正式環境系統與簽署資料。",
          "limits": "任何網路服務都無法保證絕對安全。若您認為 Collectie 帳號或資料可能有風險，請立即聯絡 contact@collectie.io，且勿在訊息中附上任何憑證。"
        },
        "changes": {
          "title": "聲明變更與聯絡方式",
          "body": "服務、供應商或法律變更時，我們可能更新本聲明。我們會在此刊登更新版本、修改生效日期；若變更對您的隱私有重大影響，亦會在服務內提供額外通知。",
          "contact": "如有隱私權問題或請求，請寄信至 contact@collectie.io。Collectie 是本聲明的負責公司。"
        }
      }
    },
    "support": {
      "metaTitle": "支援 — Collectie",
      "metaDescription": "取得 Collectie 會員、獎賞、Apple 錢包票卡、帳號與商家工具的協助。",
      "skip": "跳至 Collectie 支援",
      "eyebrow": "Collectie 支援",
      "title": "讓我們協助您找回獎賞。",
      "lede": "提供 Collectie App、Apple 錢包顧客，以及在櫃台執行集點方案的商家團隊所需協助。",
      "contactKicker": "聯絡我們",
      "contactTitle": "告訴我們發生了什麼事。",
      "contactBody": "請用一封清楚的訊息附上以下資訊。產品問題請寄至客服信箱；個人資料權利請寄至隱私權信箱。",
      "emailLabel": "產品與帳號支援",
      "privacyLabel": "隱私權請求",
      "safetyKicker": "妥善保護憑證",
      "safetyTitle": "絕對不要放進電子郵件的內容",
      "safetyBody": "請勿傳送密碼、一次性驗證碼、完整 QR Code 或票卡憑證、票卡驗證憑證、API 金鑰、簽署憑證或私密金鑰。Collectie 絕不會要求您透過電子郵件傳送這些資料。",
      "prepareKicker": "寄信之前",
      "prepareTitle": "提供四項資訊，能讓我們更快調查。",
      "prepare": {
        "device": "您的裝置型號、iOS 或瀏覽器版本，以及可取得時的 Collectie App 版本。",
        "merchant": "相關商家與分店，但請勿提供他人的個人資訊。",
        "time": "問題發生的大約時間、時區，以及問題前執行的操作。",
        "screenshot": "截圖前請遮蔽或裁掉會員代碼、QR Code、電子郵件、權杖及其他憑證。"
      },
      "topicsKicker": "常見問題",
      "topicsTitle": "先準備正確的問題資訊。",
      "topics": {
        "wallet": {
          "title": "Apple 錢包票卡",
          "body": "若票卡無法加入或更新，請先保留票卡、確認網路連線，並告訴我們是哪一家商家發行。餘額以伺服器紀錄為準；票卡暫時未更新不會改變實際獎賞紀錄。"
        },
        "rewards": {
          "title": "遺漏造訪或獎賞",
          "body": "請提供商家、分店、大約消費時間及預期看到的內容。各商家的獎賞彼此獨立，只有相關商家能確認或沖銷購買事件。"
        },
        "account": {
          "title": "更換或遺失裝置",
          "body": "請使用 App 顯示的復原流程。若仍無法存取，請在建立其他帳號前先聯絡我們，以便找出最安全可行的復原方式。"
        },
        "deletion": {
          "title": "刪除帳號",
          "body": "在 App 開啟「個人檔案 → 隱私權與資料 → 刪除帳號」。若無法存取 App，請寄信給客服並註明要刪除帳號；我們會先驗證請求再處理。"
        },
        "merchant": {
          "title": "商家櫃台或管理工具",
          "body": "若遇到登入、一次性驗證碼、裝置配對、撤銷或沖銷問題，請提供商家、分店及裝置標籤，但絕對不要附上驗證碼、工作階段憑證或簽署資料。"
        }
      },
      "responseKicker": "後續流程",
      "responseTitle": "我們會由專人檢視您的請求。",
      "responseBody": "我們會盡可能於工作日儘快回覆。個人資料權利請求會依隱私權聲明所述法定期間處理。若懷疑有安全問題，請在主旨註明「Security」，但不要附上任何憑證。",
      "privacyAction": "閱讀隱私權聲明"
    },
    "terms": {
      "metaTitle": "使用條款 — Collectie",
      "metaDescription": "使用 Collectie 會員、獎賞、Apple 錢包票卡、顧客帳號及商家工具的條款。",
      "skip": "跳至使用條款",
      "eyebrow": "使用條款 · 歐盟／歐洲經濟區與台灣",
      "title": "集點有價值，規則要清楚。",
      "lede": "本條款規範您使用 Collectie 集點服務、顧客 App、Apple 錢包票卡、公開會員頁面及商家工具的方式。",
      "factsLabel": "使用條款資訊",
      "providerLabel": "服務提供者",
      "providerName": "Collectie",
      "updatedLabel": "生效日期",
      "updatedDate": "2026 年 8 月 18 日",
      "contactLabel": "客服聯絡信箱",
      "tocLabel": "本條款內容",
      "summaryLabel": "核心約定",
      "summaryBody": "Collectie 提供記錄各商家獨立集點活動的技術。每個商家自行管理其方案，並對商品、服務及獎賞承諾負責。法律保障的消費者權利不受本條款影響。",
      "emailAction": "詢問本條款",
      "sections": {
        "agreement": {
          "title": "同意與使用資格",
          "body": "當您存取或使用 Collectie 服務，即表示同意本條款與隱私權聲明。若您代表組織使用商家工具，即確認您有權代表該組織行事。若不同意，請勿使用本服務。",
          "eligibility": "只有在法律上能有效同意本條款時，您才可使用 Collectie。當所在地法律要求父母或監護人同意時，您必須取得該同意後才能使用。"
        },
        "service": {
          "title": "Collectie 提供的服務",
          "intro": "Collectie 提供會員集點所需的軟體與基礎設施：",
          "membership": "公開商家 QR Code 可用來加入或開啟會員，但本身不代表已消費，也不會直接給予點數或獎賞；符合資格的交易仍須另行驗證。",
          "separation": "會員、進度與獎賞依商家彼此獨立，無法透過 Collectie 轉讓、合併或在其他商家兌換。",
          "availability": "功能可能依商家、分店、裝置、語言或試行階段而異。我們可改善或替換功能，但會保留適用權利及已承諾的紀錄。",
          "noPayment": "除非另有書面服務明確約定，Collectie Loyalty 並非付款服務、銀行帳戶、儲值商品或銷售點系統，也不保管您的款項。"
        },
        "accounts": {
          "title": "帳號與憑證",
          "intro": "您有責任謹慎使用帳號與憑證：",
          "accuracy": "被要求時請提供正確且最新的資訊，不得冒用他人身分，或為誤導商家或 Collectie 而建立帳號。",
          "security": "請保護裝置、票卡、帳號存取及復原資訊。若懷疑遺失、未授權存取或遭到濫用，請立即通知客服。",
          "devices": "實體裝置並非您的身分。瀏覽器、Apple 錢包、票卡與 App 紀錄是與個人相關聯的憑證，可能基於安全理由撤銷或更換。",
          "recovery": "帳號復原取決於可用且經驗證的資訊與憑證。若無法安全確認請求確屬正當，我們可能拒絕或延後復原。"
        },
        "rewards": {
          "title": "造訪、進度與獎賞",
          "intro": "交易是否符合資格及獎賞如何使用，由各商家的方案規則決定：",
          "merchantRules": "商家設定集點、兌換、到期、資格及供應規則，並應向顧客提供其他適用條件。",
          "server": "以 Collectie 伺服器紀錄為準。App 畫面或 Apple 錢包票卡只是資料呈現，在更新送達前可能短暫不是最新狀態。",
          "corrections": "符合資格的集點、加碼、兌換、到期、調整與沖銷會記錄為帳本項目。錯誤會以可稽核的調整或沖銷更正，不會悄悄刪除已成立的歷史紀錄。",
          "noValue": "除非適用法律或商家明確條款另有規定，集點進度與獎賞屬促銷性質，不具現金價值、不生利息，亦不得出售或轉讓。"
        },
        "wallet": {
          "title": "Apple 錢包與 App Store",
          "body": "Apple 錢包票卡用於顯示 Collectie 提供的會員資訊，本身並非獨立帳號，也不是已發生消費的證明。",
          "apple": "您下載及使用 iOS App 時，也必須遵守適用的 Apple App Store 條款及 Apple 標準終端使用者授權合約；若 App Store Connect 提供自訂 EULA，則依該 EULA 辦理。",
          "updates": "Apple 錢包更新需要相容的 Apple 服務、支援的裝置及可用網路。畫面更新延遲不會改變由伺服器管理的帳本紀錄。",
          "removal": "從 Apple 錢包移除票卡不會自動刪除 Collectie 帳號或集點歷史。如要刪除，請使用 App 內的帳號刪除功能或聯絡客服。"
        },
        "acceptable": {
          "title": "可接受的使用方式",
          "intro": "您不得濫用 Collectie 或協助他人濫用，尤其不得：",
          "law": "以違法方式使用服務，或侵害他人權利。",
          "access": "未經授權存取帳號、商家、分店、API、系統或資料，或規避權限與安全控制。",
          "interference": "干擾、超載、探測、擷取或逆向工程本服務；適用法律明確允許的有限範圍不在此限。",
          "fraud": "偽造或操弄消費、會員代碼、QR Code、票卡、獎賞、沖銷或其他集點活動。",
          "credentials": "分享密碼、一次性驗證碼、原始票卡或 QR Code 憑證、票卡驗證憑證、工作階段權杖、API 金鑰、憑證或私密金鑰。"
        },
        "content": {
          "title": "內容與智慧財產權",
          "intro": "本條款不會移轉服務或第三方內容的所有權：",
          "collectie": "Collectie 及其授權人保留軟體、設計、品牌與服務素材的一切權利。我們僅依本條款授予您有限、個人、可撤回且不得轉讓的服務使用權。",
          "merchant": "商家仍須對其名稱、標誌、優惠與方案內容負責。未經相關權利人同意，不得在服務外複製或使用其內容。",
          "feedback": "若您主動提供產品意見，即允許 Collectie 無償使用該意見來營運及改善服務。請勿包含機密資訊或他人的個人資料。"
        },
        "merchants": {
          "title": "參與商家",
          "body": "參與商家是獨立經營的事業。商品與服務銷售、消費驗證、方案規則、獎賞履行、商品客訴及其業務適用法令，均由商家而非 Collectie 負責。",
          "contract": "商家組織使用 Collectie 時，另行簽訂的商家服務合約可能規範商務、支援與資料處理條件。若與本公開條款就商家使用部分有所衝突，該組織應以已簽署的商家合約為準。"
        },
        "suspension": {
          "title": "停止或暫停服務",
          "body": "為保護顧客、商家或 Collectie、調查疑似濫用、遵守法律、處理安全問題或重大違約，在合理必要時可能限制或暫停存取。適當情況下，我們會說明原因並提供聯絡管道。",
          "user": "您可隨時停止使用 Collectie，並在 App 有提供時開始刪除帳號。",
          "collectie": "在可行範圍內，Collectie 可於合理通知後停止某項功能或服務。法律強制規定的退款或救濟仍然有效。",
          "records": "帳號關閉或暫停不會清除基於餘額完整性、安全、爭議或法律義務而必須保留的交易、不可竄改帳本或稽核紀錄；處理方式請參閱隱私權聲明。"
        },
        "disclaimers": {
          "title": "服務承諾與免責說明",
          "body": "我們會以合理的注意與專業提供 Collectie。在法律允許範圍內，我們不保證服務永不中斷、完全無誤或相容於所有裝置，也不保證商家持續提供某項方案、商品或獎賞。",
          "mandatory": "本條款不排除適用法律不允許排除的任何擔保、保證、救濟或其他消費者權利。"
        },
        "liability": {
          "title": "損失責任",
          "body": "若 Collectie 違反本條款，或未盡合理注意與專業，對因此直接造成且可合理預見的損失，我們會依適用法律的規則與救濟承擔責任。",
          "exclusions": "在法律允許範圍內，Collectie 不對間接或無法預見的損失、商家商品或服務、商家拒絕履行獎賞、您濫用服務或未保護憑證所生損失，以及超出我們合理控制的事件負責。",
          "mandatory": "法律禁止排除或限制的責任不受限制，包括詐欺、故意不當行為、適用時的重大過失，或因過失造成的死亡或人身傷害。法律強制保障的消費者救濟不受影響。"
        },
        "law": {
          "title": "適用法律與爭議",
          "body": "本條款不會剝奪消費者依其通常居住國法律享有的強制保障。商家組織適用的準據法與管轄法院，依其另行簽訂的商家合約決定。",
          "resolution": "請先聯絡客服，讓我們嘗試解決問題。您仍可依適用法律向有管轄權的法院、主管機關、消費者保護機構或爭議處理程序尋求協助；本條款不要求個別仲裁。"
        },
        "changes": {
          "title": "條款變更",
          "body": "我們可能因服務、安全、法律或營運變更更新本條款。我們會公布更新版本、修改生效日期；重大變更影響既有使用者時，會提前合理通知，但緊急法律或安全變更需要更快處理時不在此限。",
          "continued": "更新條款自所載生效日起適用。若您不同意，可停止使用服務並要求刪除帳號；先前已發生的權利與義務仍然有效。"
        },
        "contact": {
          "title": "聯絡方式",
          "body": "如對本條款有疑問、申訴或通知，請寄信至 contact@collectie.io。Collectie 是提供本條款所述服務的公司。",
          "privacy": "如需了解個人資料處理或行使隱私權利，請閱讀隱私權聲明或寄信至 contact@collectie.io。"
        }
      }
    },
    "legal": {
      "privacyTitle": "隱私權聲明",
      "termsTitle": "服務條款",
      "draft": "本機設計草稿",
      "notice": "此頁為設計審閱用草稿，公開前必須完成法律審閱。",
      "privacyBody": "此本機預覽不會傳送或儲存聯絡表格。公開網站開始收集個人資料前，必須清楚說明營運實體、法律依據、服務供應商、保存期限、資料權利聯絡管道，以及各地區要求的資訊揭露。",
      "termsBody": "此本機預覽不會建立商家帳戶、合約或服務承諾。公開前，營運實體、服務內容、試點條款、付款、責任與管轄法律都必須完成法律審閱。",
      "back": "返回網站"
    },
    "notFound": {
      "eyebrow": "404 · 找不到餐桌",
      "title": "找不到這個頁面。",
      "body": "網址可能已變更，或這個頁面尚未開放。",
      "back": "返回 Collectie"
    }
  },
  "app": {
    "title": "下載 Collectie 應用程式",
    "lede": "你的 Wallet 會員卡可繼續使用。應用程式讓你在同一處查看所有商店的獎賞與紀錄，並可安全地將會員卡轉移至新手機。",
    "cardKeeps": "繼續使用 Wallet 會員卡",
    "cardKeepsBody": "結帳流程不變：出示會員卡，商店掃描後印花即時更新。",
    "comingSoonTitle": "尚未於 App Store 上架",
    "comingSoonBody": "Collectie 應用程式仍在試營運測試。在此期間，你的獎賞會保存在會員卡中。",
    "download": "在 App Store 下載",
    "back": "返回 Collectie"
  }
}
